import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {isMobile} from 'helpers/ApplicationHelper';

import ItemChatBot from 'components/chatBot/itemChatBot';
import PopupHelp from 'components/popups/popupHelp';

import {updateSubmissionProgressState} from 'actions/submissionProgress';
import {itemSaveLog} from 'actions/item';

class EstimationReady extends Component {
    constructor(props) {
        super(props);

        this.state = {
            item: props.item,
            experiments: props.Experiments ? props.Experiments : null,
            shortSellDescription: isMobile() || props.Experiments.short_sell_description_desktop && props.Experiments.short_sell_description_desktop.variant === 'true',
            isShortSellDescriptionExp: props.Experiments.short_sell_description_desktop && props.Experiments.short_sell_description_desktop.variant === 'true'
        };

        this.openHelp = this.openHelp.bind(this);
    }

    componentWillUnmount() {
        this.props.updateSubmissionProgressState();
    }

    componentWillReceiveProps({Experiments}){
        if (Experiments) {
            let experiments = Experiments;
            this.setState({experiments})
        }
    }

    componentDidMount(){
        this.props.updateSubmissionProgressState('estimation presented');
    }

    openHelp() {
        PopupHelp.initPopup({single: true, modal: true});
    }

    chatBot() {
        if(this.state.experiments === null){
            return false;
        }
        return (
            <ItemChatBot
                acceptEstimation={this.props.acceptEstimation}
                generateShippingLabel={this.props.generateShippingLabel}
			/>
        );
    }

    render(){
        return (
            <div id="item-state-estimation-ready">
                <div className={`item-state-estimation-ready-container ${this.state.isShortSellDescriptionExp ? 'item-state-estimation-ready-container-short' : ''}`}>
                    {this.chatBot()}
                </div>
            </div>
        );
    }
}

EstimationReady.propTypes = {
    Loaders:                PropTypes.object,
    item:                   PropTypes.object,
    acceptEstimation:       PropTypes.func
};

EstimationReady.defaultProps = {
    item:       [],
    Loaders:    {overlay: false, _numberOfLoaders: 0}
};

const mapStateToProps = ({ADO, Experiments, Loaders, CuiVersion}) => {
    return {
        ADO,
        Experiments,
        Loaders,
        CuiVersion
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({updateSubmissionProgressState, itemSaveLog}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EstimationReady);
